import type { ReactNode } from "react";
import type { Condominio, Vista } from "@/api/preventivo";
import { PannelloBasso } from "@/components/ui/PannelloBasso";
import { FOCUS, Risultato, offertaDel } from "./parti";
import { SceltaOfferta } from "./SceltaOfferta";
import { FATTO, OFFERTA_CONDOMINIO, SCEGLI_OFFERTA, fornitureDiverse } from "./scritte";

interface Props {
  vista: Vista | null;
  /** Il condominio del pannello aperto; `null` = chiuso. */
  condominio: string | null;
  occupato: boolean;
  onScegliCondominio: (c: Condominio, offertaId: string) => void;
  onChiudi: () => void;
  /** Avviso di una scelta non salvata, dentro il pannello. */
  avviso?: ReactNode;
}

function Fatto({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`mt-4 h-12 w-full rounded-lg bg-brand-dark text-base font-semibold text-white cursor-pointer hover:bg-dark transition-colors ${FOCUS} focus-visible:ring-offset-2`}
    >
      {FATTO}
    </button>
  );
}

/** Il pannello dal basso del telefono (spec § 7.6): l'offerta del condominio (quella della sola fornitura sta nella
 *  scheda, 03/11). Uno solo per la pagina, montato qui e non dentro le schede. */
export function PannelloOfferta({ vista, condominio, occupato, onScegliCondominio, onChiudi, avviso }: Props) {
  const c = vista?.condomini.find((x) => x.chiave === condominio) ?? null;
  const offerte = vista?.offerte ?? [];

  const offerta = c ? offertaDel(c, offerte) : null;
  const diverse = c ? c.contatori.filter((x) => x.propria).length : 0;
  return (
    <PannelloBasso aperto={c !== null} onChiudi={onChiudi} titolo={c?.titolo ?? ""} sopra={offerta ? OFFERTA_CONDOMINIO : SCEGLI_OFFERTA}>
      {c && (
        <>
          <SceltaOfferta
            offerte={offerte}
            valore={offerta}
            onScegli={(id) => onScegliCondominio(c, id)}
            contesto="condominio"
            disabilitato={occupato}
            avviso={avviso}
          />
          {offerta && diverse > 0 && <p className="mt-2 text-sm text-muted-foreground">{fornitureDiverse(diverse)}</p>}
          {offerta && c.mese !== null && (
            <div className="mt-4 rounded-lg bg-surface p-3"><Risultato c={c} offerta={offerta} grande={false} /></div>
          )}
        </>
      )}
      <Fatto onClick={onChiudi} />
    </PannelloBasso>
  );
}
